var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStriker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.266,
    height: 149.193,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 164",
    d: "M57.67 129.896a9.648 9.648 0 11-9.646 9.648 9.648 9.648 0 019.646-9.648z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 165",
    d: "M67.028 141.891a9.648 9.648 0 11-18.226-6.151 11.737 11.737 0 0018.226 6.151z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 166",
    d: "M61.916 148.204l.431-1.516.527-1.794 1.806-.458 1.528-.386a9.684 9.684 0 01-4.292 4.154z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 167",
    d: "M55.075 136.869l-.508 1.794-.512 1.793 1.3 1.339 1.3 1.337 1.806-.458 1.808-.455.508-1.794.51-1.792-1.3-1.339-1.3-1.337-1.806.455z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 168",
    d: "M59.706 132.37l1.809-.453 1.528-.386a9.668 9.668 0 012.8 2.874l-.434 1.512-.508 1.794-1.808.455-1.806.458-1.286-1.332-1.313-1.336.51-1.794z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 169",
    d: "M53.415 130.883l-.429 1.513-.51 1.8 1.3 1.339 1.3 1.337 1.81-.461 1.806-.455.51-1.794.508-1.792-1.3-1.339-1.1-1.135a9.656 9.656 0 00-3.895.987z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 170",
    d: "M63.04 131.527l-1.526.39-1.808.458-1.3-1.339-1.096-1.14a9.639 9.639 0 015.73 1.631z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 171",
    d: "M67.296 140.196l-1.1-1.131-1.3-1.337.508-1.794.437-1.516a9.643 9.643 0 011.455 5.778z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 172",
    d: "M48.046 138.902l1.1 1.128 1.3 1.337-.5 1.794-.431 1.516a9.641 9.641 0 01-1.469-5.775z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 173",
    d: "M52.299 147.559l1.528-.386 1.808-.455 1.3 1.337 1.1 1.128a9.643 9.643 0 01-5.732-1.624z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 174",
    d: "M49.14 135.036l1.519-.386 1.808-.458.508-1.794.431-1.516a9.684 9.684 0 00-4.266 4.154z",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 175",
    d: "M21.031 53.974s-8.258 27.343-4.73 41.877l2.261-.295s13.713-30.9 16.609-35.558z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 176",
    d: "M78.661 9.908s-41.156 1.644-57.63 44.066l14.139 6.024 3.815-4.547 13.661 24.2s11.337 4.408 24.35-4.633l-7.335-41.79 8.206-5.046z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 374",
    opacity: 0.4,
    fill: "#ef7f33"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 177",
    d: "M59.096 79.135c-.694.253-18.506-34.511-18.506-34.511-16.959 11.1-22.2 44.2-23.1 51.075l1.079-.142s13.706-30.9 16.6-35.558l3.815-4.547 13.661 24.2a20.556 20.556 0 006.2 1.04c.268-1.005.355-1.595.251-1.557z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M16.3 95.852l.475-.062-.822-1.804c.09.645.212 1.269.347 1.866z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 179",
    d: "M108.205 10.349a5.35 5.35 0 01.062-.572c-12.96-1.647-29.6.132-29.6.132l-.794 18.273 30.19-14.622a30.114 30.114 0 01.142-3.211z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 180",
    d: "M108.257 9.776a13.771 13.771 0 012.081-.746c.347 0 1.148-1.144 1.54-1.068.839.166-.4 1.98-.4 1.98s4.276-1.113 4.075-.347-3.589 1.2-3.589 1.2 3.638-.284 3.34.284-3.246.475-3.246.475 3.094.877 2.081 1.186a4.016 4.016 0 01-2.334-.274s1.873 1.113.746 1.245a7.1 7.1 0 01-2.535-.347l-1.946.163s-.544-3.359.187-3.751z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 181",
    d: "M107.771 140.437s-1.28 3.146.818 3.371 12.086 1.04 11.663.406-9.364-5.511-9.364-5.511z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 182",
    d: "M102.94 92.664l-14.084-9.548-11.864-8.087-24.339 4.633-8.323 12.319-8.348 10.4C28.9 91.689 8.705 94.363 8.705 94.363l-1.734 2.15 30.956 23.376c13.04-1.554 24.006-13.709 24.006-13.709l5-7.654s9.27 13.966 26.229 7.529c-4.633 10.689 14.694 34.771 14.694 34.771l3.371-.347z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 183",
    d: "M25.72 109.991a34.476 34.476 0 013.815-13c-8.747-4.221-20.829-2.625-20.829-2.625l-1.734 2.15 18.71 14.115c.013-.213.02-.425.038-.64z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 184",
    d: "M94.53 118.878c4.207 10.581 13.328 21.946 13.328 21.946l3.371-.347-4.411-25.407a34.42 34.42 0 01-12.288 3.808z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 185",
    d: "M94.725 87.095l-5.868-3.978-11.864-8.088-24.339 4.633-8.323 12.319-4.266 5.31c2.362 5.095 6.884 12.249 14.51 15.343a53.107 53.107 0 007.366-6.458l4.994-7.654a22.775 22.775 0 0014.393 8.989c4.782-3.77 11.548-10.647 13.397-20.416z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 186",
    d: "M60.855 24.779l-1.711 5.057-10.5-1.263-1.2-6.787 4.335-2.254 8.722 5.154z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 187",
    d: "M48.179 25.94a31.028 31.028 0 0010.963 3.884 2.482 2.482 0 00-1.47 3.146c.61 2.452-12.7-.926-9.811-8.826z",
    fill: "#f4efef"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 188",
    d: "M59.141 29.825s2.4.409 3.319 2.053c0 0 5.2-7.71-1.359-11.122s-2.837 7.058-2.837 7.058z",
    fill: "#f4efef"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 189",
    d: "M57.182 3.776l.08.156 5.747 10.845-2.161.281s2.618 9.218 1.356 10.422-11.445 4.786-15.645-5.525-3.028-14.791-3.028-14.791z",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 190",
    d: "M42.182 8.24s9.981 4.2 17.5-7a30.67 30.67 0 00-3.773-.818 17.838 17.838 0 00-7.63 0 8.076 8.076 0 00-4.623 2.452 7.5 7.5 0 00-1.474 5.366z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 191",
    d: "M49.292 8s-2.553 3.042-1.328 5.656-.52 8.129-.52 8.129-5.927-6.087-5.261-13.546S49.292 8 49.292 8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 192",
    d: "M50.381 13.337s-2.937-2.937-3.69-1.165 4 3.506 4 3.506l-.288-2.209",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 193",
    d: "M58.226 10.529l-.475-.444-2.022 1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 194",
    d: "M57.914 8.757l-.954-.76.149.309-.319-.187v.2l-2.039.694-2.251 2.126 3.211-1.942 1.509-.184s-.059-.347.049-.291a2.041 2.041 0 01.271.191z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 195",
    d: "M61.441 17.33l-1.353 1.1 1.529-.357z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 196",
    d: "M9.364 94.846s-2.147-2.632-3.35-.9-6.707 10.1-5.941 10.04 9.329-5.58 9.329-5.58z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 197",
    d: "M20.937 107.053l1.512 1.151c.555-3.263 1.772-9.017 3.863-12.485a25.668 25.668 0 00-1.453-.416 27.184 27.184 0 00-3.922 11.75z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 198",
    d: "M107.348 118.13c-2.865 1.273-7.737 3.208-11.583 3.583q.347.718.694 1.429a26.416 26.416 0 0011.185-3.329z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 199",
    d: "M44.331 91.981l-8.348 10.4c-3.947-5.972-11.958-7.765-18.3-8.2l-.784-.049-.925-.034a48.846 48.846 0 00-7.283.267l.659 1.072s13.442 13.037 27.8 13.023 22.626-29.579 21.918-29.326c-.055.021-.229-.2-.5-.607l-5.948 1.134z",
    fill: "#ef7f33",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 200",
    d: "M93.156 106.05c-3.919 9.055 9.336 27.717 13.48 33.211l-11.912-39.19c-10.59 5.483-27.79-1.55-27.79-1.55s9.263 13.966 26.222 7.529z",
    fill: "#ef7f33",
    opacity: 0.4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStriker);
export default __webpack_public_path__ + "static/media/striker.1b71d7ec.svg";
export { ForwardRef as ReactComponent };